export function cx(...values) {
  return values.filter(Boolean).join(' ');
}

export function mergeStyles(...maps) {
  const merged = {};

  for (const map of maps) {
    for (const [key, value] of Object.entries(map)) {
      merged[key] = merged[key] ? `${merged[key]} ${value}` : value;
    }
  }

  return merged;
}